<app-input-wrapper
	label="Suggested LRO's"
	*ngIf="filteredSuggestedLROs?.length > 0"
	[testHook]="testHooks.InputWrapper"
>
	<ng-container *ngFor="let lro of filteredSuggestedLROs">
		<app-pill
			*ngIf="LRO?.selected?.id !== lro.id"
			(click)="setLRO(lro)"
			[select]="true"
			[testHook]="testHooks.Pill"
		>
			{{ lro.name }} ({{ lro.id }})
		</app-pill>
	</ng-container>
</app-input-wrapper>
